import React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseCard } from './BaseCard';
import { TotalEntitiesCardProps } from './CardProps';
import { DASHBOARD_CARD_TITLE_KEYS } from './dashboardCardKeys';
import { DashboardMetricContent } from './DashboardMetricContent';

export const TotalEntitiesCard: React.FC<TotalEntitiesCardProps> = ({
  cardId,
  entities,
  onClick,
}) => {
  const { t } = useTranslation();
  const cardTitle = t(DASHBOARD_CARD_TITLE_KEYS[cardId]!);

  return (
    <BaseCard cardId={cardId} title={null} onClick={onClick}>
      <DashboardMetricContent
        label={cardTitle}
        value={entities?.length || 0}
      />
    </BaseCard>
  );
};
